const pageSections = {
    SPOTLIGHT: 'SPOTLIGHT',
    NOTIFICATIONS: 'NOTIFICATIONS',
    FAVORITES: 'FAVOURITES',
    RECENT_UPDATES: 'RECENT_UPDATES',
};

export default pageSections;
